<template>
  <div class="product animatedBox">
    <div class="container fluid">
      <div class="card p-1">
        <fd-table
          :componentTitle="'Products'"
          :routerButton="routerButton"
          :tableButton="actionButton"
          :indexed="true"
          :plugin="{}"
          :getFunction="getAllProducts"
        ></fd-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "product",
  data() {
    return {
      routerButton: [
        {
          title: "Add Product",
          class: "add",
          routerLink: "/product/add",
        },
      ],
      actionButton: [
        {
          title: "Edit",
          class: "edit",
          routerLink: "/product/edit",
        },
        {
          title: "Delete",
          class: "delete",
          routerLink: null,
          onclick: async (id) => {
            const c = confirm(
              "Are you sure to remove this product? You cannot undo after this."
            );

            if (c) {
              return this.removeProduct(id);
            }
          },
          getData: true,
        },
      ],
    };
  },
  methods: {
    async getAllProducts(keyword, currentPage, perPage, isLoading) {
      const request = await this.$store.dispatch("product/getAllProducts", {
        keyword: keyword,
        currentPage: currentPage,
        perPage: perPage,
        isLoading: isLoading,
      });

      return request;
    },
    async removeProduct(id) {
      const request = await this.$store.dispatch("product/deleteProduct", id);

      return request;
    },
  },
};
</script>

<style>
.product {
}
</style>